export enum StaffAccessLevels {
  HomeUser = "Facility User",
  HomeAdmin = "Facility Admin",
  OrgAdmin = "Org Admin",
  MaintenanceAdmin = "Maintenance Admin",
  MaintenanceUser = "Maintenance User",
}

export const SupeAdminAccessLevel = "SuperAdmin"